module.exports = __webpack_public_path__ + "assets/img/service-aba166a6.png";